var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameMenuBack = function SvgIconStorygameMenuBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.478A2 2 0 0 1 3.772 8.9l7-5.444a2 2 0 0 1 2.456 0l7 5.444A2 2 0 0 1 21 10.48V19.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9.022Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17h7",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgIconStorygameMenuBack;